import Dce from "dce-engine/lib/decorators/Dce";
import DceComponent from "dce-engine/lib/engine/DceComponent";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import dragula from "dragula";
import findFragmentParent from "dce-fragments/lib/fragments/utils/findFragmentParent";
import { Fragment } from "dce-fragments";

interface ReorderDragulaProps {
    containerSelector: string;
    wireAction: string;
}

@Dce("ReorderDragula")
export default class ReorderDragula extends DceComponent<ReorderDragulaProps> {
    private parentFragment: Fragment;

    constructor(elem: DceHTMLElement, props: ReorderDragulaProps) {
        super(elem, props);

        console.log("DDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDD");
        this.parentFragment = findFragmentParent(elem);

        let container: HTMLElement = elem;
        if(this.props.containerSelector){
            container = this.elem.querySelector(this.props.containerSelector) as HTMLElement;
        }

        let timeout:any = null;

        let drake = dragula([container], {

            mirrorContainer: this.elem,

            moves: (el, container1, handle) => {

                if(handle.classList.contains("order-handle")){
                    return true;
                }

                return el.querySelector('.order-handle').contains(handle);

            },

            removeOnSpill: false,
        }).on("drop", async (el, target, source, sibling) => {

            if(null != timeout){
                clearTimeout(timeout);
            }

            setTimeout(async () => {
                let order: number[] = [];

                container.querySelectorAll("[data-id]").forEach((elem) => {

                    order.push(
                        parseInt((elem as HTMLElement).dataset['id'])
                    );

                });


                if(this.props.wireAction) {
                    let resp = await this.parentFragment.call(
                        this.props.wireAction,
                        {
                            ids: order.join("|")
                        }
                    );
                }

                console.log("DROPPPP", order);
            }, 100);


        }).on("cloned", (clone, original, type) => {
            let a = clone as HTMLElement;

            a.style.backgroundColor = "#ffffff";
        })

    }

    public action(o: any){

    }

}
